<template>
  <div class="driver-page-wrapper p-3"> <h3 class="page-title mb-3">
      <i class="fa fa-id-card-alt mr-2"></i> Hồ Sơ Xe & Giấy Tờ
    </h3>

    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 mb-0 text-muted">Đang tải hồ sơ...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      <i class="fa fa-exclamation-triangle mr-2"></i> {{ error }}
      <button v-if="error.includes('hết hạn')" class="btn btn-sm btn-warning ml-2" @click="logoutAndRedirect">Đăng nhập lại</button>
    </div>

    <div v-else-if="!hasHoSo" class="text-center py-5 text-muted">
      <i class="fa fa-info-circle fa-2x mb-2"></i>
      <p>Không có thông tin hồ sơ hoặc bạn chưa được phân công xe.</p>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <div class="card h-100 shadow-sm">
            <div class="card-header bg-success text-white font-weight-bold">
              <i class="fa fa-user fa-fw mr-2"></i> Thông Tin Tài Xế
            </div>
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <img :src="hoSo.taiXe?.avatarUrl || '/assets/img/avatar-placeholder.png'"
                     class="rounded-circle mr-3"
                     style="width: 60px; height: 60px; object-fit: cover; border: 2px solid #eee;">
                <div>
                  <h5 class="mb-0 font-weight-bold">{{ hoSo.taiXe?.hoTen || 'N/A' }}</h5>
                  <p class="mb-0 text-muted">{{ hoSo.taiXe?.chucVu || 'Tài xế' }}</p>
                </div>
              </div>
              <p class="mb-1"><i class="fa fa-phone fa-fw mr-2 text-muted"></i> {{ hoSo.taiXe?.soDienThoai || '-' }}</p>
              <p class="mb-0"><i class="fa fa-envelope fa-fw mr-2 text-muted"></i> {{ hoSo.taiXe?.email || '-' }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-8 mb-3">
          <div class="card h-100 shadow-sm">
            <div class="card-header bg-primary text-white font-weight-bold">
              <i class="fa fa-car fa-fw mr-2"></i> Xe Đang Phân Công
            </div>
            <div v-if="!hoSo.xeHienTai" class="card-body text-muted text-center py-5">
                <i class="fa fa-info-circle fa-2x mb-2"></i>
                <p>Hiện tại bạn chưa được phân công xe nào.</p>
            </div>
            <div v-else class="card-body">
               <div class="row">
                  <div class="col-md-5 mb-3 mb-md-0">
                      <img :src="hoSo.xeHienTai?.fileUrl || '/assets/img/placeholder-car.png'"
                           alt="Ảnh xe"
                           style="width: 100%; height: 150px; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;">
                  </div>
                  <div class="col-md-7">
                       <h5 class="mb-2 font-weight-bold">Biển số: {{ hoSo.xeHienTai.bienSo }}</h5>
                       <p class="mb-1"><i class="fa fa-car-side fa-fw mr-2 text-muted"></i> <strong>Loại xe:</strong> {{ hoSo.xeHienTai.tenLoaiXe || '-' }}</p>
                       <p class="mb-1"><i class="fa fa-copyright fa-fw mr-2 text-muted"></i> <strong>Hãng:</strong> {{ hoSo.xeHienTai.hangXe || '-' }}</p>
                       <p class="mb-0"><i class="fa fa-car fa-fw mr-2 text-muted"></i> <strong>Model:</strong> {{ hoSo.xeHienTai.model || '-' }}</p>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm mt-3">
         <div class="card-header font-weight-bold">
            <i class="fa fa-folder-open mr-2"></i> SOS
         </div>
         <SosComponent />
      </div>

      <div class="card shadow-sm mt-3">
         <div class="card-header font-weight-bold">
            <i class="fa fa-folder-open mr-2"></i> Yêu cầu bảo dưỡng
         </div>
         <TaiXeBaoDuong />
      </div>

      <div class="card shadow-sm mt-3">
         <div class="card-header font-weight-bold">
            <i class="fa fa-folder-open mr-2"></i> Tài xế checklist
         </div>
         <TaiXeChecklist />
      </div>

      <div class="card shadow-sm mt-3">
         <div class="card-header font-weight-bold">
            <i class="fa fa-folder-open mr-2"></i> Tài xế đổ xăng
         </div>
         <TaiXeDoXang
            :xeId="hoSo.xeHienTai.id" 
            @submit-success="handleXangDauSuccess"
         />
      </div>

      <div class="card shadow-sm mt-3">
         <div class="card-header font-weight-bold">
            <i class="fa fa-folder-open mr-2"></i> Danh Sách Giấy Tờ Liên Quan
         </div>
         <div v-if="hoSo.danhSachGiayTo.length === 0" class="card-body text-muted text-center py-4">
             Không có giấy tờ nào được tìm thấy.
         </div>
         <div v-else class="list-group list-group-flush">
             <div v-if="giayToXe.length > 0">
                 <h6 class="list-group-item bg-light font-weight-bold text-primary">
                    <i class="fa fa-car mr-2"></i> Giấy Tờ Xe ({{ giayToXe.length }})
                 </h6>
                 <a v-for="gt in giayToXe" :key="'xe-'+gt.id"
                    href="#" @click.prevent="viewFile(gt.fileUrl)"
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                    <div>
                       <strong class="d-block">{{ gt.tenHienThi || gt.tenLoaiGiayToDisplay }}</strong>
                       <small class="text-muted">Số: {{ gt.soGiayTo || 'N/A' }}</small>
                    </div>
                    <div class="text-right">
                       <span :class="['badge', gt.active ? 'badge-success' : 'badge-secondary', 'mr-2']">
                         {{ gt.active ? 'Hiệu lực' : 'Hết HL' }}
                       </span>
                       <br>
                       <small :class="{'text-danger font-weight-bold': isExpired(gt.ngayHetHan), 'text-warning': isNearExpiry(gt.ngayHetHan)}">
                         Hạn: {{ formatDate(gt.ngayHetHan) || 'Không TH' }}
                         <i v-if="isExpired(gt.ngayHetHan)" class="fa fa-exclamation-circle text-danger ml-1" title="Đã hết hạn"></i>
                         <i v-else-if="isNearExpiry(gt.ngayHetHan)" class="fa fa-exclamation-triangle text-warning ml-1" title="Sắp hết hạn"></i>
                       </small>
                    </div>
                    <i v-if="gt.fileUrl" class="fa fa-external-link-alt ml-2 text-info" title="Xem file"></i>
                 </a>
             </div>

             <div v-if="giayToTaiXe.length > 0">
                 <h6 class="list-group-item bg-light font-weight-bold text-success mt-2">
                   <i class="fa fa-user mr-2"></i> Giấy Tờ Cá Nhân ({{ giayToTaiXe.length }})
                 </h6>
                 <a v-for="gt in giayToTaiXe" :key="'tx-'+gt.id"
                    href="#" @click.prevent="viewFile(gt.fileUrl)"
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                    <div>
                       <strong class="d-block">{{ gt.tenHienThi || gt.tenLoaiGiayToDisplay }}</strong>
                       <small class="text-muted">Số: {{ gt.soGiayTo || 'N/A' }}</small>
                    </div>
                     <div class="text-right">
                       <span :class="['badge', gt.active ? 'badge-success' : 'badge-secondary', 'mr-2']">
                         {{ gt.active ? 'Hiệu lực' : 'Hết HL' }}
                       </span>
                       <br>
                       <small :class="{'text-danger font-weight-bold': isExpired(gt.ngayHetHan), 'text-warning': isNearExpiry(gt.ngayHetHan)}">
                         Hạn: {{ formatDate(gt.ngayHetHan) || 'Không TH' }}
                          <i v-if="isExpired(gt.ngayHetHan)" class="fa fa-exclamation-circle text-danger ml-1" title="Đã hết hạn"></i>
                         <i v-else-if="isNearExpiry(gt.ngayHetHan)" class="fa fa-exclamation-triangle text-warning ml-1" title="Sắp hết hạn"></i>
                       </small>
                    </div>
                     <i v-if="gt.fileUrl" class="fa fa-external-link-alt ml-2 text-info" title="Xem file"></i>
                 </a>
             </div>
         </div>
      </div>

    </div>

    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import { useHoSoXeStore } from '@/stores/hoSoXeStore';
// Import helper format ngày tháng (nếu có)
import SosComponent from './SosComponent.vue';
import TaiXeBaoDuong from './TaiXeBaoDuong.vue';
import TaiXeChecklist from './TaiXeChecklist.vue';
import TaiXeDoXang from './TaiXeDoXang.vue';

export default {
  name: 'HoSoXeCuaToi',
  components: { 
    SosComponent, // Dùng dấu {} thay vì <>
    TaiXeBaoDuong,
    TaiXeChecklist,
    TaiXeDoXang
  },
  computed: {
    // Map state và getters từ hoSoXeStore
    ...mapState(useHoSoXeStore, ['isLoading', 'error', 'hoSo']),
    ...mapGetters(useHoSoXeStore, ['giayToXe', 'giayToTaiXe', 'hasHoSo']),
  },
  methods: {
    // Map actions
    ...mapActions(useHoSoXeStore, ['fetchHoSoCuaToi', 'clearHoSo']),

    // --- Helpers (Giống QuanLyGiayTo.vue) ---
    formatDate(dateString) {
      if (!dateString) return null; // Trả về null để kiểm tra dễ hơn
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return null;
      }
    },
    isExpired(dateString) {
      if (!dateString) return false;
      try {
        const expiryDate = new Date(dateString);
        const today = new Date();
        expiryDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        return expiryDate < today;
      } catch (e) { return false; }
    },
    isNearExpiry(dateString, daysThreshold = 30) {
      if (!dateString || this.isExpired(dateString)) return false;
      try {
        const expiryDate = new Date(dateString);
        const today = new Date();
        const diffTime = expiryDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= daysThreshold;
      } catch (e) { return false; }
    },

    // Hàm xem file (mở link mới hoặc hiển thị modal)
    viewFile(url) {
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        alert('Giấy tờ này chưa có file đính kèm.');
      }
    },

    // Hàm xử lý khi lỗi token hết hạn (ví dụ)
    logoutAndRedirect() {
        this.clearHoSo(); // Xóa state store
        // Gọi action logout của store auth (nếu có)
        // Ví dụ: useAuthStore().logout();
        this.$router.push('/login'); // Chuyển về trang đăng nhập
    },
    handleXangDauSuccess(newLog) {
        // Khi báo xăng dầu thành công
        console.log("Fuel report successful, log ID:", newLog.id);
        // (Không cần làm gì, component con đã tự xử lý)
    }
  },
  mounted() {
    // Gọi API lấy hồ sơ khi component được mount
    this.fetchHoSoCuaToi();
  },
   beforeUnmount() {
    // (Tùy chọn) Có thể xóa state khi rời component nếu không muốn cache
    // this.clearHoSo();
  }
};
</script>

<style scoped>
.driver-page-wrapper {
  max-width: 1200px; /* Giới hạn chiều rộng cho dễ nhìn */
  margin: 0 auto; /* Căn giữa */
}
.page-title {
  color: #333;
}
.card-header {
  font-size: 1.1rem;
}
.list-group-item strong {
    color: #007bff; /* Màu nhấn cho tên giấy tờ */
}
.list-group-item small.text-muted{
    font-size: 0.85em;
}
.list-group-item:hover {
    background-color: #f8f9fa; /* Highlight khi hover */
}
/* Thêm style cho icon xem file */
.list-group-item .fa-external-link-alt {
    transition: transform 0.2s ease-in-out;
}
.list-group-item:hover .fa-external-link-alt {
    transform: scale(1.2);
}
</style>